import { TreatmentSourceType } from 'components/TreatmentProgressMenu/TreatmentMenuConfig';
import { Classification, FilesData } from 'types/Files.types';
import {
  RESIM_FILE_UPLOAD_STATUS,
  TreatmentDocumentInput,
  TreatmentDocumentType
} from 'types/TreatmentPlanning.types';

export const buildNewScanDocumentsInput = (
  documents?: FilesData[],
  isSmartee?: boolean
): TreatmentDocumentInput[] => {
  return (documents ?? [])
    .filter((document) => !!document?.key)
    .map((document) => ({
      key: document.key,
      name: document?.file?.name ?? document?.fileName ?? document.key ?? '',
      documentType: TreatmentDocumentType.NEW_SCAN,
      sourceType: TreatmentSourceType.PRESCRIPTIONS,
      classification: Classification.PRIOR_TREATMENT_SCAN,
      ...(isSmartee && {
        resimFilesUploadStatus: RESIM_FILE_UPLOAD_STATUS.PENDING
      })
    }));
};
